define.alias("ember-cli-string-helpers/helpers/capitalize", "media/helpers/capitalize");